import { Component } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalConstants } from 'functions/src/shared/global-constants';
import { debounceTime, pairwise, startWith } from 'rxjs/operators';
import { MainsComponent } from 'src/common/pages/mains/mains.component';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { SelectService } from 'src/common/services/select/select.service';
import { SettingService } from 'src/common/services/setting/setting.service';
import { Action } from 'src/services/action/action.model';
import { ActionDealService } from 'src/services/action/action.service';
import { StatService } from 'src/services/stat/stat.service';

@Component({
  selector: 'app-deals',
  templateUrl: './deals.component.html',
  styleUrls: ['./deals.component.scss']
})
export class DealsComponent extends MainsComponent {

  // public newRequests: ActionService = null;
  public actionItem = new Action(null, this.setting);
  public GLOBAL = new GlobalConstants();

  showLegend: boolean = false;
  showLabels: boolean = false;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';


  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = false;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Year';
  showYAxisLabel: boolean = true;
  yAxisLabel: string = 'Leads';
  animations: boolean = true;

  year: number = new Date().getFullYear();
  years: number[] = [];

  public customColors: any[] = [
    { name: 'Cold', value: '#B1E9E1' }, // Red
    { name: 'Warm', value: '#FF8C00' }, // Green
    { name: 'Hot', value: '#FF4500' }, // Blue
    { name: 'VEFA', value: '#4CAF50' }, // Blue
    // Add more mappings as needed
  ];

  // public preview: any = null;

  constructor(
    protected afs: AngularFirestore,
    public db: ActionDealService,
    public settings: SettingService,
    public backURL: BackurlService,
    protected router: Router,
    public setting: SettingService,
    public select: SelectService,
    protected fb: FormBuilder,
    public stats: StatService,
  ) {
    super(setting, db, select, router, fb, backURL);

    this.sortServerForm = this.fb.group({
      agency: [],
      realtor: [],
      year: [this.year],
      arrayFilters: this.fb.group({
        agencies: [''],
        realtors: [''],
      }),
      multiFilters: {
        type: ['signLease', 'signAgree'],
      },
      filters: this.fb.group({
        done: [true],
      }),
    });

    this.sortLocalForm = this.fb.group({
      arrayFilters: this.fb.group({
        realtors: [''],
      }),
    });


    for (let year = 2018; year <= this.year; year++) {
      this.years.push(year);
    }
  }

  protected _initPages(): void {

    if (this.db.isRole('realtor')) {
      this.sortServerForm.get('arrayFilters.agencies').setValue(null);
      this.sortServerForm.get('arrayFilters.realtors').setValue(this.db.selectRealtorFilter());
    } else {
      this.sortServerForm.get('arrayFilters.agencies').setValue(this.db.selectAgencyFilter());
      this.sortLocalForm.get('arrayFilters.realtors').setValue(this.db.selectRealtorFilter());
    }

    this.stats.initList("sales", this.sortServerForm.value.arrayFilters.agencies, this.sortLocalForm.value.arrayFilters.realtors, this.sortServerForm.value.year, null, null, null, false);

    this.db.setFilters({ server: this.sortServerForm.value, local: this.sortLocalForm.value });

    this.sortServerForm.valueChanges
      .pipe(
        startWith(this.sortServerForm.value),
        pairwise(),
        debounceTime(500)
      )
      .subscribe(([previous, current]) => {
        // Check if agencies changed
        if (previous?.arrayFilters?.agencies !== current?.arrayFilters?.agencies) {
          this.sortLocalForm.get('arrayFilters.realtors').setValue('');
        }

        setTimeout(() => {
          this.stats.initList("sales", this.sortServerForm.value.arrayFilters.agencies, this.sortLocalForm.value.arrayFilters.realtors, this.sortServerForm.value.year, null, null, null, false);
        }, 10);
      });

    this.sortLocalForm.valueChanges.pipe(debounceTime(500)).subscribe(() => {
      setTimeout(() => {
        this.stats.initList("sales", this.sortServerForm.value.arrayFilters.agencies, this.sortLocalForm.value.arrayFilters.realtors, this.sortServerForm.value.year, null, null, null, false);
      }, 10);
    });
  }

  // changeTime($event: any) {
  //   this.sortLocalForm.get('filters.time').setValue($event.value);
  //   this.db.setLocalFilter(this.sortLocalForm.value);
  //   this.db.refreshActionTypes(this.sortLocalForm.value.filters.time);
  //   if (!this.db.actionTypes[this.sortLocalForm.value.filters.type]) {
  //     this.changeType('');
  //   }
  // }

  // changeType($event: any) {
  //   this.sortLocalForm.get('filters.type').setValue($event.value);
  //   this.db.setLocalFilter(this.sortLocalForm.value);
  // }


  calculTotal(element: any, displayCy: boolean = false) {
    let total = 0;
    const selectedRealtor = this.sortLocalForm.value.arrayFilters.realtors;
    const selectedAgency = this.sortLocalForm.value.arrayFilters.agencies;

    if (selectedRealtor) {
      if (element.mandate.realtor === selectedRealtor) {
        total = total + element.mandateCA;
      }
      if (element.project.realtor === selectedRealtor) {
        total = total + element.projectCA;
      }
    } else if (selectedAgency) {
      if (element.mandate.agency === selectedAgency) {
        total = total + element.mandateCA;
      }
      if (element.project.agency === selectedAgency) {
        total = total + element.projectCA;
      }
    } else {
      total = element.mandateCA + element.projectCA;
    }
    if (displayCy && element.cy && element.cy !== 'mur' && element.xrate) {
      total = total * element.xrate;
    }
    return Math.round(total);
  }


  goItem(item: any) {
    this.backURL.addURL('/deals');
    this.router.navigate([`/tasks/${item.$key}`]);
  }


}
